var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPassword = function SvgPassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.66665H11.1667V4.99998C11.1667 2.69998 9.30004 0.833313 7.00004 0.833313C4.70004 0.833313 2.83337 2.69998 2.83337 4.99998V6.66665H2.00004C1.08337 6.66665 0.333374 7.41665 0.333374 8.33331V16.6666C0.333374 17.5833 1.08337 18.3333 2.00004 18.3333H12C12.9167 18.3333 13.6667 17.5833 13.6667 16.6666V8.33331C13.6667 7.41665 12.9167 6.66665 12 6.66665ZM4.50004 4.99998C4.50004 3.61665 5.61671 2.49998 7.00004 2.49998C8.38337 2.49998 9.50004 3.61665 9.50004 4.99998V6.66665H4.50004V4.99998ZM12 16.6666H2.00004V8.33331H12V16.6666ZM7.00004 14.1666C7.91671 14.1666 8.66671 13.4166 8.66671 12.5C8.66671 11.5833 7.91671 10.8333 7.00004 10.8333C6.08337 10.8333 5.33337 11.5833 5.33337 12.5C5.33337 13.4166 6.08337 14.1666 7.00004 14.1666Z",
    fill: "#ABADAD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password.d7fef4a1.svg";
export { ForwardRef as ReactComponent };